import React from "react";
import styles from "./UseCases.module.scss";
const WhyUs = () => {
  const useCases = [
    {
      title: "Wholesale & bulk ordering",
      description:
        "Retailers place bulk inventory from manufacturers or distributors at scale.",
      points: [
        "Bulk discounts and tiered pricing",
        "MOQ (Minimum Order Quantity) & max order quantity",
        "Real-time stock visibility",
      ],
    },
    {
      title: "B2B marketplace",
      description:
        "Platforms where multiple businesses list products and buyers and sellers transact.",
      points: [
        "Seller & buyer onboarding",
        "Bulk orders with multi-seller shipping",
      ],
    },
    {
      title: "Manufacturing and made-to-order",
      description:
        "Custom products manufactured based on buyer specifications in bulk.",
      points: [
        "Configurable product options",
        "Real-time production tracking",
        "Automated order processing",
      ],
    },
    {
      title: "Subscription and recurring orders",
      description:
        "Periodic delivery of goods or services based on subscription models.",
      points: [
        "Auto-scheduled orders below inventory threshold",
        "Customizable shipments",
        "Pre-integrated payments and shipping solutions",
      ],
    },
    {
      title: "Hyperlocal business supply",
      description:
        "Suppliers use pre-built platform to manage orders, inventory and fulfillment for local businesses.",
      points: [
        "Automated RFP and approvals",
        "Contract management for recurring orders",
      ],
    },
    {
      title: "Procurement & supply management",
      description:
        "Organizations procure goods or services from suppliers through centralized platform.",
      points: [
        "Automated RFP and approvals",
        "Offline payments via cheques and transfers",
      ],
    },
    {
      title: "Distribution network",
      description:
        "Distributors connect manufacturers with retailers, managing logistics and inventory.",
      points: [
        "Region-based order allocation",
        "Real-time warehouse stock visibility",
        "Tiered contract pricing per client",
      ],
    },
  ];

  return (
    <section className={styles["platform-section"]}>
      <div className={styles["platform-container"]}>
        <div className={styles["platform-card"]}>
        <div className={styles["platform-header"]}>
          <h2 className="heading">Industry-specific use cases</h2>
        </div>
          <div className={styles["platform-grid"]}>
            {useCases.map((item, index) => (
              <div key={index} className={styles["function-card"]}>
                <h4>{item.title}</h4>

                <p className={styles["function-description"]}>
                  {item.description}
                </p>

                <div className={styles["function-list"]}>
                  {item.points.map((point, pointIndex) => (
                    <div key={pointIndex} className={styles["function-item"]}>
                      <div className={styles["dot"]} />
                      <span>{point}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
